import React, { useContext, useEffect, useState } from 'react'

// import 'bootstrap/dist/css/bootstrap.min.css'; 
import { Carousel } from 'react-bootstrap';

import home_4 from "../../Assets/images/home2.jpg"

import nursing from "../../Assets/homePage/nursing.png";
import face from "../../Assets/homePage/face-brush.png";
import drugs from "../../Assets/homePage/drugs.png";
import eyes from "../../Assets/homePage/eyes.png";
import hospital from "../../Assets/homePage/hospital.png";
import radiation from "../../Assets/homePage/radiation.png";
import physical from "../../Assets/homePage/physical.png";
import tooth from "../../Assets/homePage/tooth.png";
import test from "../../Assets/homePage/blood-test.png";
import free from "../../Assets/homePage/free.png";
import suger from "../../Assets/homePage/suger.jpg";
import heat from "../../Assets/homePage/heat.jpg";
import prescription from "../../Assets/homePage/prescription.png";
import stomach from "../../Assets/homePage/stomach.png";
import { Link } from 'react-router-dom';
import getGreeting from "../../Utilities/getGreeting.js"



import "./test.css"
import { UserContext } from '../../Context/UserContext.js';
import axios from 'axios';
import { toast } from 'react-toastify';
import ProfileSlider from '../ProfileSlider/ProfileSlider.jsx';



export default function Testing() {




   const [adverts, setAdverts] = useState([]);
   const { loggedUser, userToken } = useContext(UserContext);
   const header = {
      token: `${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}`
   }


   const services = [
      // { name: "الأسنان", icon: tooth  , url:"/teeth" , isActive:false}, 
      // { name: "الأشعة", icon: radiation  , url:"/radiologyProfile" , isActive:true}, 
      { name: "الأشعة", icon: radiation, url: "/offers", isActive: true },
      { name: " التحاليل", icon: test, url: "/offers", isActive: true },
      // { name: "المناظير", icon: stomach  , url:"/endoscopes" , isActive:false}, 
      // { name: "العيون", icon: eyes  , url:"/eyes" , isActive:false}, 
      // { name: "التجميل", icon: face , url:"/cosmetology" , isActive:false}, 
      // { name: "العلاج الطبيعى", icon: physical  , url:"/physicalTherapy" , isActive:false} ,
      // { name: "المستشفيات", icon: hospital  , url:"/hospital" , isActive:false}, 
      // { name: "الصيدلية", icon: drugs  , url:"/pharmacy" , isActive:false} ,
      // { name: "التمريض", icon: nursing  , url:"/nursing" , isActive:false} 
   ];



   async function getAdverts() {
      await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/advert`, { headers: header })
         .then(({ data }) => {
            if (data.message === "success") {
               setAdverts(data.adverts);
            }
         })
         .catch((error) => {
            // toast.error(error.response?.data.message)
         })
   }


   useEffect(() => {
      getAdverts()
   }, [])

   return (
      <div className=" container main-container">
         {/* Info Section with Slider */}
         <section className="home-slider p-3 rounded-2 mb-3 bg-light">
            <div className='greeterLargeMedia'>
               <p className=' text-center fw-bold fs-3 ps-4'>{getGreeting()}</p>
               <p className=' text-center fw-bold fs-3'>{loggedUser?.name?.toLowerCase().split(" ").map(word => word.charAt(0)?.toUpperCase() + word?.slice(1)).slice(0, 2).join(" ")}</p>
               <h3 className="header-title-text m-0 d-flex justify-content-center  align-item-center gap-1">
                  <span className="main-color">SMART</span>
                  <span className="ps-1 ">TREND</span>
               </h3>            </div>
            <Carousel indicators={false} controls={true} interval={2000} >
               {adverts.map((ele) => (
                  <Carousel.Item key={ele._id} className='carousel-item'>
                     <div className="text-center carousel-div">
                        <img src={ele.image} alt="cover" className='w-100 carousel-img' />
                     </div>
                  </Carousel.Item>
               ))}
            </Carousel>
         </section>


         {/* Services Grid */}
         <div className="row g-2 bg-body-secondary rounded-2 home-box justify-content-evenly align-item-center">
            {services.map((service, index) => (
               <div key={index} className={`col-4 col-lg-2 my-1`}>
                  <Link to={service.isActive ? service.url : "#"}>
                     <div className="position-relative">
                        <div className={`card text-center p-1 `}>
                           <div className="mb-1"><img src={service.icon} className='imageCard' alt="cover" /></div>
                           <p className='m-0 fs-5 fw-bold'>{service.name}</p>
                        </div>
                        {!service.isActive ?
                           <div className='position-absolute w-100 h-100 bg-dark-subtle top-0 end-0 opacity-25 '></div>
                           :
                           ''
                        }
                     </div>
                  </Link>
               </div>
            ))}
         </div>


         <div className='my-5 text-center'>
            {/* <Link to="/SendPrescription" className='btn btn-secondary w-75 ' ><i className="fa-regular fa-image me-2"></i> ارسال روشتة</Link> */}
            <Link className="btn bgBlack text-white w-75 " to="https://wa.me/201066991090" > ارسال روشتة </Link>
         </div>

         <div className='position-relative my-5'>
            <hr />
            <h2 className='offer-title fs-4'>عروض  متنوعة</h2>
         </div>

         <ProfileSlider />

      </div>
   )
}







